import { StackedCellText } from '@/components/common/DataTable';
import { EmptyValue } from '@/components/common/EmptyValue';
import { ExpandableComment } from '@/components/common/ExpandableComment';
import { VerifyRouteLink } from '@/features/moTravel/components/VerifyRouteLink';

interface AreaRouteCellProps {
  fromName: string | null;
  toName: string | null;
  comments: string | null;
  userId: number;
  personName: string | null;
  dcrDate: string;
}

export function AreaRouteCell({
  fromName,
  toName,
  comments,
  userId,
  personName,
  dcrDate,
}: AreaRouteCellProps) {
  return (
    <StackedCellText
      primary={
        <>
          {fromName ?? <EmptyValue />}
          {' – '}
          {toName ?? <EmptyValue />}{' '}
          <VerifyRouteLink
            userId={userId}
            personName={personName}
            date={dcrDate}
            className="align-middle"
          />
        </>
      }
      secondary={comments ? <ExpandableComment comment={comments} /> : null}
    />
  );
}
